import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Share2, Check } from 'lucide-react';

interface ShareButtonProps {
    title: string;
    text: string;
    url?: string;
    className?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({ title, text, url = window.location.href, className = '' }) => {
    const { t } = useTranslation('ShareButton');
    const [copied, setCopied] = useState(false);

    const handleShare = async (e: React.MouseEvent) => {
        e.stopPropagation();

        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    text,
                    url,
                });
            } catch (err) {
                console.error('Share failed:', err);
                copyToClipboard();
            }
        } else {
            copyToClipboard();
        }
    };

    const copyToClipboard = () => {
        const fullText = `${title}\n\n${text}\n\n${t('readMoreHere', { url })}`;
        navigator.clipboard.writeText(fullText).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <button
            onClick={handleShare}
            className={`flex items-center gap-2 transition-all ${copied ? 'text-skjeta-green' : 'text-gray-400 hover:text-white'} ${className}`}
            title={t('share')}
        >
            {copied ? <Check size={16} /> : <Share2 size={16} />}
            <span className="text-xs font-bold uppercase tracking-wider">{copied ? t('copied') : t('share')}</span>
        </button>
    );
};
